export default __webpack_public_path__ + "static/media/loreofskelos.a98869ff.png";